import {Path, Svg} from 'react-native-svg'

import {useSemanticTokens} from '#/wsocial/service/design-system'

export const LockIcon = () => {
  const tokens = useSemanticTokens()
  return (
    <Svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      style={{flexShrink: 0}}>
      <Path
        fill={tokens.onboarding.btnPrimaryBg}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 7a5 5 0 0 1 10 0v2h1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h1V7Zm-1 4v9h12v-9H6Zm9-2H9V7a3 3 0 1 1 6 0v2Zm-3 4a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z"
      />
    </Svg>
  )
}

export default LockIcon
